import { Add, Button, DropdownContent, DropdownMenu, DropdownMenuItem, DropdownTrigger } from "@bcc-ui/ui-components";
import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { CreateAssetCustomViewSubpage } from "components/asset-management-system/custom-views/CreateAssetCustomViewSubpage";
import { CreateAssetFolderModal } from "components/asset-management-system/custom-views/CreateAssetFolderModal";
import { subpageContext } from "components/layout/ApplicationLayout";
import style from "components/navigation/navigation-panel/sub-navigation-panel/sub-navigation-panel.scss";
import { Breakpoint } from "domain/breakpoints";
import { StoreState } from "store";

import testIds from "testIds.json";

export const AssetsCreateNewButton = () => {
    const { t } = useTranslation();
    const views = useSelector((state: StoreState) => state.assetViewsReducer.views);
    const context = React.useContext(subpageContext);
    const isMobileResolution = window.innerWidth < Breakpoint.MD;

    const [isCreateAssetFolderModalOpen, setIsCreateAssetFolderModalOpen] = React.useState(false);

    const openCreateAssetFolderModal = () => {
        context?.setSubpage({
            content: (
                <CreateAssetCustomViewSubpage
                    parentUuid={undefined}
                    folders={(views ?? []).filter((view) => view.folder)}
                />
            ),
            isModal: false,
        });

        if (isMobileResolution) {
            context?.closeSubNavigationPanel();
        }
    };

    return (
        <>
            <DropdownMenu closeOnSelection position="top-start" dropdownOffset={"Xxs"}>
                <DropdownTrigger>
                    <Button
                        variant={"Tertiary"}
                        icon={<Add size={20} color={"--app-subNavigationPanel-iconColor"} />}
                        className={classNames(style.navigationButton)}
                        testId={testIds.navigation.assets.assetViews.createAssetViewButton}
                    >
                        {t("Common.createNew")}
                    </Button>
                </DropdownTrigger>

                <DropdownContent>
                    <DropdownMenuItem onClick={() => setIsCreateAssetFolderModalOpen(true)}>
                        {t("AssetManagement.createAssetCustomView.createFolder")}
                    </DropdownMenuItem>

                    <DropdownMenuItem onClick={openCreateAssetFolderModal}>
                        {t("AssetManagement.createAssetCustomView.createGroup")}
                    </DropdownMenuItem>
                </DropdownContent>
            </DropdownMenu>

            <CreateAssetFolderModal
                isOpen={isCreateAssetFolderModalOpen}
                onClose={() => setIsCreateAssetFolderModalOpen(false)}
            />
        </>
    );
};
